import { EnrollmentStepType } from "@/api/signin";
import { buttonVariants } from "@/components/ui/button/button-variants";
import { useAuth } from "@/context/auth-context";
import { Link } from "@tanstack/react-router";
import { CheckCircle, InfoIcon } from "lucide-react";
import MenuButton from "../../_components/MenuButton";

export default function SecurityChecklistPage() {
	const { user } = useAuth();

	const hasCompletedIdentityVerification = hasCompletedStep(
		"IDENTITY_VERIFICATION",
	);
	const hasCompletedFaceIdEnrollment = hasCompletedStep("BIOMETRIC_ENROLLMENT");

	const hasCompletedEmailVerification = hasCompletedStep("EMAIL_VERIFICATION");

	function hasCompletedStep(step: EnrollmentStepType) {
		return user.location_registration?.missing_steps.includes(step) === false;
	}

	function getIcon(isCompleted: boolean) {
		if (isCompleted) {
			return <CheckCircle />;
		}

		return <InfoIcon />;
	}

	function getSubText(isCompleted: boolean) {
		if (isCompleted) {
			return "Completed";
		}

		return "Not completed";
	}

	return (
		<div>
			<MenuButton
				subText={getSubText(hasCompletedIdentityVerification)}
				label="Identity Verification"
				iconColor={hasCompletedIdentityVerification ? "primary" : "gray"}
				icon={getIcon(hasCompletedIdentityVerification)}
				rightElement={
					hasCompletedIdentityVerification ? (
						<div></div>
					) : (
						<Link
							className={buttonVariants({
								variant: "outline",
								size: "sm",
							})}
							to="/main/verify-identity"
						>
							Get started
						</Link>
					)
				}
			/>
			<MenuButton
				iconColor={hasCompletedEmailVerification ? "primary" : "gray"}
				label="Verify Email"
				icon={getIcon(hasCompletedEmailVerification)}
				subText={getSubText(hasCompletedEmailVerification)}
				rightElement={<div></div>}
			/>
			<MenuButton
				iconColor={hasCompletedFaceIdEnrollment ? "primary" : "gray"}
				label="Face ID Enrollment"
				icon={getIcon(hasCompletedFaceIdEnrollment)}
				subText={getSubText(hasCompletedFaceIdEnrollment)}
				rightElement={
					hasCompletedFaceIdEnrollment ? (
						<div></div>
					) : (
						<Link
							className={buttonVariants({
								variant: "outline",
								size: "sm",
							})}
							to="/alt/face-registration"
						>
							Get started
						</Link>
					)
				}
			/>
		</div>
	);
}
